import React from 'react';
import UnauthorizedContainer from '@src/containers/Unauthorized';

const Unauthorized = () => <UnauthorizedContainer />;

export default Unauthorized;
